<template>
  <div class="page flex-col">
    <div class="block_1 flex-row">
      <div class="image-wrapper_1 flex-col">
        <img
          class="image_1"
          referrerpolicy="no-referrer"
          src="./assets/img/5e639a76efd71797912292afdde6c43e.png"
          alt="Logo"
        />
        <img
          class="image_2"
          referrerpolicy="no-referrer"
          src="./assets/img/d1579a4780b873faa1994ac4b70d21ae.png"
          alt="Title"
        />
      </div>
      <img
        class="image_3"
        referrerpolicy="no-referrer"
        src="./assets/img/ef87f2cc880c491a7442fe767e4254ff.png"
        alt="Main image"
      />
      <div class="box_1 flex-col">
        <span class="text_1">contact&nbsp;via&nbsp;mail&nbsp;：&nbsp;cfan0582&#64;gmail.com</span>
        <img
          class="image_4"
          referrerpolicy="no-referrer"
          src="./assets/img/f90a8dc3cc10202f6f5554963fa3968e.png"
          alt="Contact image"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LanhuH5',
  data() {
    return {
      constants: {}
    };
  },
  metaInfo() {
    return {
      meta: [
        { name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no' }
      ]
    };
  },
  methods: {}
};
</script>
<style scoped>
.page {
  background-color: rgba(255, 255, 255, 1);
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
}

.block_1 {
  background-image: linear-gradient(
    rgba(92, 217, 229, 1) 0,
    rgba(92, 217, 229, 1) 0,
    rgba(69, 135, 199, 1) 100%,
    rgba(69, 135, 199, 1) 100%
  );
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.image-wrapper_1 {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 5vh;
}

.image_1 {
  width: 30%;
  max-width: 200px;
  height: auto;
  margin: 0 auto;
}

.image_2 {
  width: 70%;
  max-width: 461px;
  height: auto;
  margin: 4vh auto 2vh;
}

.image_3 {
  width: 90%;
  max-width: 712px;
  height: auto;
  margin: 0 auto;
}

.box_1 {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 5vh;
}

.text_1 {
  width: 90%;
  max-width: 558px;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-family: AdobeHeitiStd-Regular, sans-serif;
  text-align: center;
  line-height: 1.5;
  margin: 3vh auto;
}

.image_4 {
  width: 80%;
  max-width: 563px;
  height: auto;
  margin: 0 auto;
}

/* 通用弹性布局样式 */
.flex-col {
  display: flex;
  flex-direction: column;
}

.flex-row {
  display: flex;
  flex-direction: column; /* 在移动设备上默认为列布局 */
}

/* 响应式布局 */
@media screen and (min-width: 768px) {
  .text_1 {
    font-size: 20px;
  }
  
  /* 在大屏幕上可以调整为行布局 */
  .flex-row {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }
}

@media screen and (min-width: 1024px) {
  .text_1 {
    font-size: 24px;
  }
}
</style>